"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var react_split_pane_1 = __importDefault(require("react-split-pane"));
var JSONRPCRequestEditor_1 = __importDefault(require("./JSONRPCRequestEditor"));
var monaco = __importStar(require("monaco-editor"));
var PlayCircleFilled_1 = __importDefault(require("@material-ui/icons/PlayCircleFilled"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var FlashOn_1 = __importDefault(require("@material-ui/icons/FlashOn"));
var FlashOff_1 = __importDefault(require("@material-ui/icons/FlashOff"));
var History_1 = __importDefault(require("@material-ui/icons/History"));
var Add_1 = __importDefault(require("@material-ui/icons/Add"));
var Description_1 = __importDefault(require("@material-ui/icons/Description"));
var core_1 = require("@material-ui/core");
var Brightness3_1 = __importDefault(require("@material-ui/icons/Brightness3"));
var WbSunny_1 = __importDefault(require("@material-ui/icons/WbSunny"));
var react_monaco_editor_1 = __importDefault(require("@etclabscore/react-monaco-editor"));
var useTabs_1 = __importDefault(require("../hooks/useTabs"));
var use_debounce_1 = require("use-debounce");
var colors_1 = require("@material-ui/core/colors");
var schema_utils_js_1 = require("@open-rpc/schema-utils-js");
var useMonacoVimMode_1 = __importDefault(require("../hooks/useMonacoVimMode"));
var monaco_add_json_schema_diagnostics_1 = require("@etclabscore/monaco-add-json-schema-diagnostics");
var openrpcDocumentToJSONRPCSchemaResult_1 = __importDefault(require("../helpers/openrpcDocumentToJSONRPCSchemaResult"));
var TransportDropdown_1 = __importDefault(require("../components/TransportDropdown"));
var useTransport_1 = __importDefault(require("../hooks/useTransport"));
var defaultTransports = [{
  type: "http",
  name: "HTTP"
}, {
  type: "websocket",
  name: "WebSocket"
}, {
  type: "postmessagewindow",
  name: "PostMessageWindow"
}, {
  type: "postmessageiframe",
  name: "PostMessageIframe"
}];
var errorToJSON = function (error, id) {
  var isError = error instanceof Error;
  if (!isError) {
    return;
  }
  if (!error) {
    return;
  }
  var emptyErrorResponse = {
    jsonrpc: "2.0",
    id: id
  };
  // this is an internal wrapped client-js error
  if (error.data instanceof Error) {
    return __assign(__assign({}, emptyErrorResponse), {
      error: {
        code: error.data.code,
        message: error.data.message,
        data: error.data.data
      }
    });
  }
  return __assign(__assign({}, emptyErrorResponse), {
    error: {
      code: error.code,
      message: error.message,
      data: error.data
    }
  });
};
var emptyJSONRPC = {
  jsonrpc: "2.0",
  method: "",
  params: [],
  id: 0
};
var Inspector = function (props) {
  var _a = useTabs_1.default([{
      name: props.request ? props.request.method : "New Tab",
      content: props.request || __assign({}, emptyJSONRPC),
      url: props.url || "",
      openrpcDocument: props.openrpcDocument
    }]),
    setTabContent = _a.setTabContent,
    setTabEditing = _a.setTabEditing,
    setTabIndex = _a.setTabIndex,
    tabs = _a.tabs,
    setTabs = _a.setTabs,
    handleClose = _a.handleClose,
    tabIndex = _a.tabIndex,
    setTabOpenRPCDocument = _a.setTabOpenRPCDocument,
    setTabUrl = _a.setTabUrl,
    handleLabelChange = _a.handleLabelChange,
    setTabResults = _a.setTabResults;
  var _b = react_1.useState(),
    responseEditor = _b[0],
    setResponseEditor = _b[1];
  useMonacoVimMode_1.default(responseEditor);
  var _c = react_1.useState(props.openrpcDocument),
    openrpcDocument = _c[0],
    setOpenRpcDocument = _c[1];
  var _d = react_1.useState(props.request || {
      jsonrpc: "2.0",
      method: "",
      params: [],
      id: 0
    }),
    json = _d[0],
    setJson = _d[1];
  var _e = react_1.useState(),
    results = _e[0],
    setResults = _e[1];
  var _f = react_1.useState(defaultTransports),
    transportList = _f[0],
    setTransportList = _f[1];
  var _g = react_1.useState(props.url || ""),
    url = _g[0],
    setUrl = _g[1];
  var debouncedUrl = use_debounce_1.useDebounce(url, 1000)[0];
  var _h = react_1.useState(defaultTransports[0]),
    selectedTransport = _h[0],
    setSelectedTransport = _h[1];
  var _j = useTransport_1.default(transportList, debouncedUrl, defaultTransports[0]),
    transport = _j[0],
    setTransport = _j[1],
    connected = _j[3];
  var _k = react_1.useState(false),
    historyOpen = _k[0],
    setHistoryOpen = _k[1];
  var _l = react_1.useState([]),
    requestHistory = _l[0],
    setRequestHistory = _l[1];
  var _m = react_1.useState(0),
    historySelectedIndex = _m[0],
    setHistorySelectedIndex = _m[1];
  react_1.useEffect(function () {
    setTabs(__spreadArrays(tabs, [{
      name: props.request ? props.request.method || "New Tab" : "New Tab",
      content: props.request,
      url: props.url,
      openrpcDocument: openrpcDocument
    }]));
    setTabIndex(tabs.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.request]);
  react_1.useEffect(function () {
    if (selectedTransport !== undefined) {
      setTransport(selectedTransport);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTransport]);
  react_1.useEffect(function () {
    if (!openrpcDocument) {
      return;
    }
    if (!responseEditor) {
      return;
    }
    if (!results) {
      return;
    }
    var schema = openrpcDocumentToJSONRPCSchemaResult_1.default(openrpcDocument, json.method);
    var modelName = "inspector-results";
    var modelUriString = "inmemory://" + modelName + "-" + Math.random() + ".json";
    var modelUri = monaco.Uri.parse(modelUriString);
    var model = monaco.editor.createModel(results ? JSON.stringify(results, null, 4) : "", "json", modelUri);
    if (responseEditor) {
      responseEditor.setModel(model);
    }
    monaco_add_json_schema_diagnostics_1.addDiagnostics(modelUri.toString(), schema, monaco);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results, responseEditor, openrpcDocument]);
  react_1.useEffect(function () {
    if (json) {
      setTabContent(tabIndex, json);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [json]);
  react_1.useEffect(function () {
    if (props.transport) {
      var t = defaultTransports.find(function (tp) {
        return tp.type === props.transport;
      });
      if (t) {
        setSelectedTransport(t);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.transport]);
  react_1.useEffect(function () {
    if (props.url) {
      setUrl(props.url);
      setTabUrl(tabIndex, props.url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.url]);
  var handlePlayButton = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var result, r, newHistory, e_1, convertedError, newHistory;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            clear();
            if (!transport) return [3 /*break*/, 4];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, transport.sendData({
              internalID: json.id,
              request: json
            })];
          case 2:
            result = _a.sent();
            r = {
              jsonrpc: "2.0",
              result: result,
              id: json.id
            };
            setResults(r);
            setTabResults(tabIndex, r);
            newHistory = __spreadArrays(requestHistory, [__assign({}, tabs[tabIndex])]);
            setRequestHistory(newHistory);
            return [3 /*break*/, 4];
          case 3:
            e_1 = _a.sent();
            convertedError = errorToJSON(e_1, json.id);
            newHistory = __spreadArrays(requestHistory, [__assign({}, tabs[tabIndex])]);
            setRequestHistory(newHistory);
            setResults(convertedError);
            setTabResults(tabIndex, convertedError);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  function handleResponseEditorDidMount(__, editor) {
    setResponseEditor(editor);
  }
  var clear = function () {
    setResults(undefined);
    setTabResults(tabIndex, undefined);
  };
  var handleClearButton = function () {
    clear();
  };
  var handleToggleDarkMode = function () {
    if (props.onToggleDarkMode) {
      props.onToggleDarkMode();
    }
  };
  var refreshOpenRpcDocument = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var d, doc, e_2;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 3,, 4]);
            return [4 /*yield*/, (_a = transport) === null || _a === void 0 ? void 0 : _a.sendData({
              internalID: 999999,
              request: {
                jsonrpc: "2.0",
                params: [],
                id: 999999,
                method: "rpc.discover"
              }
            })];
          case 1:
            d = _b.sent();
            return [4 /*yield*/, schema_utils_js_1.parseOpenRPCDocument(d)];
          case 2:
            doc = _b.sent();
            setOpenRpcDocument(doc);
            setTabOpenRPCDocument(tabIndex, doc);
            return [3 /*break*/, 4];
          case 3:
            e_2 = _b.sent();
            if (!props.openrpcDocument) {
              setOpenRpcDocument(undefined);
              setTabOpenRPCDocument(tabIndex, undefined);
            }
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  react_1.useEffect(function () {
    if (!props.openrpcDocument) {
      setOpenRpcDocument(undefined);
    }
    refreshOpenRpcDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transport, tabIndex]);
  react_1.useEffect(function () {
    if (tabs[tabIndex]) {
      setJson(tabs[tabIndex].content);
      setUrl(tabs[tabIndex].url || "");
      setResults(tabs[tabIndex].results);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex]);
  react_1.useEffect(function () {
    setOpenRpcDocument(props.openrpcDocument);
    setTabOpenRPCDocument(tabIndex, props.openrpcDocument);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.openrpcDocument]);
  var handleTabIndexChange = function (event, newValue) {
    setTabIndex(newValue);
  };
  var onHistoryPlayClick = function () {
    if (requestHistory[historySelectedIndex]) {
      setJson(requestHistory[historySelectedIndex].content);
      setUrl(requestHistory[historySelectedIndex].url);
      setOpenRpcDocument(requestHistory[historySelectedIndex].openrpcDocument);
      setResults(undefined);
      setHistoryOpen(false);
    }
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(core_1.Dialog, {
    onClose: function () {
      return setHistoryOpen(false);
    },
    "aria-labelledby": "simple-dialog-title",
    open: historyOpen
  }, react_1.default.createElement(core_1.Container, {
    maxWidth: "sm"
  }, react_1.default.createElement(core_1.Grid, {
    container: true,
    justify: "space-between",
    alignItems: "center",
    style: {
      padding: "30px",
      paddingTop: "10px",
      paddingBottom: "10px"
    }
  }, react_1.default.createElement(core_1.Typography, {
    color: "textPrimary"
  }, "History"), requestHistory.length === 0 ? null : react_1.default.createElement(core_1.Tooltip, {
    title: "Use"
  }, react_1.default.createElement(core_1.IconButton, {
    onClick: onHistoryPlayClick
  }, react_1.default.createElement(PlayCircleFilled_1.default, null)))), requestHistory.length === 0 ? react_1.default.createElement(core_1.Typography, {
    style: {
      padding: "30px"
    }
  }, "No History Yet.") : react_1.default.createElement(core_1.Grid, {
    container: true,
    style: {
      paddingBottom: "30px"
    }
  }, react_1.default.createElement(core_1.List, {
    style: {
      padding: "10px",
      overflowY: "scroll",
      height: "250px",
      width: "200px"
    }
  }, requestHistory.map(function (requestHistoryItem, historyIndex) {
    return react_1.default.createElement(core_1.ListItem, {
      button: true,
      onClick: function () {
        return setHistorySelectedIndex(historyIndex);
      },
      selected: historyIndex === historySelectedIndex
    }, react_1.default.createElement(core_1.ListItemText, {
      primary: requestHistoryItem.content.method || "Empty Method",
      secondary: requestHistoryItem.url || "Empty Url"
    }));
  })), react_1.default.createElement(react_monaco_editor_1.default, {
    width: "300px",
    height: "250px",
    value: requestHistory[historySelectedIndex] ? JSON.stringify(requestHistory[historySelectedIndex].content, null, 4) : "",
    language: "json",
    editorDidMount: function () {
      // noop
    }
  })))), react_1.default.createElement("div", {
    style: {
      position: "relative"
    }
  }, react_1.default.createElement(core_1.Tabs, {
    style: {
      background: "transparent"
    },
    value: tabIndex,
    variant: "scrollable",
    indicatorColor: "primary",
    onChange: handleTabIndexChange
  }, tabs.map(function (tab, index) {
    return react_1.default.createElement(core_1.Tab, {
      disableRipple: true,
      style: {
        border: "none",
        outline: "none",
        userSelect: "none"
      },
      onDoubleClick: function () {
        return setTabEditing(tab, true);
      },
      label: react_1.default.createElement("div", {
        style: {
          userSelect: "none"
        }
      }, tab.editing ? react_1.default.createElement(core_1.InputBase, {
        value: tab.name,
        onChange: function (ev) {
          return handleLabelChange(ev, tab);
        },
        onBlur: function () {
          return setTabEditing(tab, false);
        },
        autoFocus: true,
        style: {
          maxWidth: "80px",
          marginRight: "25px"
        }
      }) : react_1.default.createElement(core_1.Typography, {
        style: {
          display: "inline",
          textTransform: "none",
          marginRight: "25px"
        },
        variant: "body1"
      }, tab.name), tabIndex === index ? react_1.default.createElement(core_1.Tooltip, {
        title: "Close Tab"
      }, react_1.default.createElement(core_1.IconButton, {
        onClick: function (ev) {
          return handleClose(ev, index);
        },
        style: {
          position: "absolute",
          right: "10px",
          top: "25%"
        },
        size: "small"
      }, react_1.default.createElement(Close_1.default, null))) : null)
    });
  }), react_1.default.createElement(core_1.Tab, {
    disableRipple: true,
    style: {
      minWidth: "50px"
    },
    label: react_1.default.createElement(core_1.Tooltip, {
      title: "Create New Tab"
    }, react_1.default.createElement(core_1.IconButton, {
      onClick: function () {
        return setTabs(__spreadArrays(tabs, [{
          name: "New Tab",
          content: __assign(__assign({}, emptyJSONRPC), {
            id: 0
          }),
          openrpcDocument: openrpcDocument,
          url: url
        }]));
      }
    }, react_1.default.createElement(Add_1.default, {
      scale: 0.5
    })))
  }))), react_1.default.createElement(core_1.AppBar, {
    elevation: 0,
    position: "static",
    style: {
      zIndex: 1
    }
  }, react_1.default.createElement(core_1.Toolbar, null, react_1.default.createElement("img", {
    height: "30",
    alt: "openrpc-logo",
    style: {
      marginRight: "10px"
    },
    src: "https://github.com/open-rpc/design/raw/master/icons/open-rpc-logo-noText/open-rpc-logo-noText%20(PNG)/128x128.png" //tslint:disable-line
  }), react_1.default.createElement(core_1.Typography, {
    variant: "h6",
    color: "textSecondary"
  }, "Inspector"), react_1.default.createElement(TransportDropdown_1.default, {
    transports: transportList,
    onAddTransport: function (addedTransport) {
      setTransportList(__spreadArrays(transportList, [addedTransport]));
    },
    selectedTransport: selectedTransport,
    onChange: function (changedTransport) {
      return setSelectedTransport(changedTransport);
    },
    style: {
      marginLeft: "10px"
    }
  }), react_1.default.createElement(core_1.Tooltip, {
    title: "Play"
  }, react_1.default.createElement(core_1.IconButton, {
    onClick: handlePlayButton
  }, react_1.default.createElement(PlayCircleFilled_1.default, {
    fontSize: "large"
  }))), react_1.default.createElement(core_1.InputBase, {
    startAdornment: react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(core_1.Tooltip, {
      title: connected ? "Connected" : "Not Connected"
    }, connected ? react_1.default.createElement(FlashOn_1.default, {
      style: {
        color: colors_1.green[500]
      }
    }) : react_1.default.createElement(FlashOff_1.default, {
      color: "error"
    })), openrpcDocument ? react_1.default.createElement(core_1.Tooltip, {
      title: react_1.default.createElement("div", {
        style: {
          textAlign: "center"
        }
      }, react_1.default.createElement(core_1.Typography, null, "OpenRPC Document Detected"), react_1.default.createElement(core_1.Typography, {
        variant: "caption"
      }, "A JSON-RPC endpoint may respond to the rpc.discover method or a provide a static document. This adds features like auto completion to the inspector.")),
      onClick: function () {
        return window.open("https://spec.open-rpc.org/#service-discovery-method");
      }
    }, react_1.default.createElement(Description_1.default, {
      style: {
        color: colors_1.green[500],
        marginRight: "5px",
        cursor: "pointer"
      },
      scale: 0.1
    })) : null),
    value: url,
    placeholder: "Enter a JSON-RPC server URL",
    onChange: function (event) {
      setUrl(event.target.value);
      setTabUrl(tabIndex, event.target.value);
    },
    fullWidth: true,
    style: {
      background: "rgba(0,0,0,0.1)",
      borderRadius: "4px",
      padding: "0px 10px",
      marginRight: "5px"
    }
  }), react_1.default.createElement(core_1.Tooltip, {
    title: "History"
  }, react_1.default.createElement(core_1.IconButton, {
    onClick: function () {
      return setHistoryOpen(true);
    }
  }, react_1.default.createElement(History_1.default, null))), props.hideToggleTheme ? null : react_1.default.createElement(core_1.Tooltip, {
    title: "Toggle Theme"
  }, react_1.default.createElement(core_1.IconButton, {
    onClick: handleToggleDarkMode
  }, props.darkMode ? react_1.default.createElement(Brightness3_1.default, null) : react_1.default.createElement(WbSunny_1.default, null))))), react_1.default.createElement(react_split_pane_1.default, {
    split: "vertical",
    minSize: 100,
    maxSize: -100,
    defaultSize: "50%",
    style: {
      flexGrow: 1
    },
    onChange: function () {
      if (responseEditor) {
        responseEditor.layout();
      }
    }
  }, react_1.default.createElement(JSONRPCRequestEditor_1.default, {
    onChange: function (val) {
      var jsonResult;
      try {
        jsonResult = JSON.parse(val);
      } catch (e) {
        console.error(e);
      }
      if (jsonResult) {
        setJson(jsonResult);
        setTabContent(tabIndex, jsonResult);
      }
    },
    openrpcDocument: openrpcDocument,
    value: JSON.stringify(json, null, 4)
  }), react_1.default.createElement(react_1.default.Fragment, null, results && react_1.default.createElement(core_1.Button, {
    style: {
      position: "absolute",
      top: "15px",
      right: "15px",
      zIndex: 1
    },
    onClick: handleClearButton
  }, "Clear"), results ? react_1.default.createElement(react_monaco_editor_1.default, {
    editorOptions: {
      minimap: {
        enabled: false
      },
      wordWrap: "on",
      lineNumbers: "off",
      wrappingIndent: "deepIndent",
      readOnly: true,
      showFoldingControls: "always",
      fixedOverflowWidgets: true,
      automaticLayout: true
    },
    height: "93vh",
    editorDidMount: handleResponseEditorDidMount,
    language: "json",
    value: JSON.stringify(results, null, 4) || ""
  }) : react_1.default.createElement(core_1.Grid, {
    container: true,
    justify: "center",
    style: {
      paddingTop: "20px"
    },
    direction: "column",
    alignItems: "center"
  }, react_1.default.createElement(core_1.Typography, {
    variant: "body1",
    gutterBottom: true,
    color: "textSecondary",
    style: {
      paddingBottom: "15px"
    }
  }, "Press the Play button to see the results here."), react_1.default.createElement(core_1.Typography, {
    variant: "body1",
    color: "textSecondary"
  }, "Use ", react_1.default.createElement(core_1.Button, {
    variant: "contained",
    disabled: true,
    size: "small",
    style: {
      marginRight: "3px"
    }
  }, "CTRL + SPACE"), "to auto-complete in the editor.")))));
};
exports.default = Inspector;